import { render, staticRenderFns } from "./PackageDeclarationChangeReport.vue?vue&type=template&id=f3c874da"
import script from "./PackageDeclarationChangeReport.vue?vue&type=script&lang=js"
export * from "./PackageDeclarationChangeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports